export const REQUEST_VENDOR_DETAILS = 'REQUEST_VENDOR_DETAILS'
export const RECEIVE_VENDOR_DETAILS = 'RECEIVE_VENDOR_DETAILS'
export const STOP_RECEIVING_VENDOR_DETAILS = 'STOP_RECEIVING_VENDOR_DETAILS'
export const REQUEST_VENDOR_PRODUCTS = 'REQUEST_VENDOR_PRODUCTS';
export const RECEIVE_VENDOR_PRODUCTS = 'RECEIVE_VENDOR_PRODUCTS';
export const NO_VENDOR_PRODUCTS_EXIST = 'NO_VENDOR_PRODUCTS_EXIST';
export const STOP_RECEIVING_VENDOR_PRODUCTS = 'STOP_RECEIVING_VENDOR_PRODUCTS';
